
    import { defineComponent } from 'vue'
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import FamilyCombined from '@/apps/shared/services/familyCombinedQuotation-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import ProductCardsSelector from '@/apps/shared/components/ProductCardsSelector.vue';

    export default defineComponent({
        components: {
            XBreadcrumb,
            ProductCardsSelector
        },
        data() {
            return {

                tabTwoData: null,
                tabThreeData: null,

                isBack: false,

                DescriptionDiscount20: null,
                Discount20: false,
                DescriptionDiscount21: null,
                Discount21: false,
                DescriptionDiscount22: null,
                Discount22: false,
                DescriptionDiscount23: null,
                Discount23: false,
                breadcrumItems: [
                    { text: 'Inicio', path: '/hogar-premium' },
                    { text: 'Cotizá tu hogar', path: '/hogar-premium/cotizar' },
                    { text: 'Valor del hogar', path: '/hogar-premium/valor-vivienda' },
                    { text: 'Seguridad del hogar', path: '/hogar-premium/seguridad-vivienda' },

                ],
                buildingCapital: null,
                checkValid: false,
                buildTypeCode: null,
                dataWelcomeJson: null,
                areaCode: null,
                telephone: null,
                email: null,
                discountRate: null,
                containDiscountRange: false,
                responseFamilyCombined927Quotation: null,
                backExit: false,
                systemSecurity: [],
                referente: null,
                medium: null,
                pas: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Hogar Premium';
                const actualPath = '/hogar-premium';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultFamilyCombinedGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'tabThreeFamilyCombinedPremium',
                })
            },

            cotizar() {
                this.tabThreeData = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                var validSelectedArticleCode = false;
                var validSelectedSurfaceHouse = false;
                var validSelectedBuildingCapital = false;
                var validSelectedLocality = false;
                if (this.tabTwoData.articleCode != null) {
                    validSelectedArticleCode = true;
                }
                else {
                    validSelectedArticleCode = false;
                }

                if (this.tabTwoData.surfaceHouse != null) {
                    validSelectedSurfaceHouse = true;
                }
                else {
                    validSelectedSurfaceHouse = false;
                }
                if (this.tabThreeData.code != null) {
                    validSelectedBuildingCapital = true;
                }
                else {
                    validSelectedBuildingCapital = false;
                }
                if (this.tabTwoData.selectedLocality != null) {
                    validSelectedLocality = true;
                }
                else {
                    validSelectedLocality = false;
                }

                if (validSelectedArticleCode && validSelectedSurfaceHouse && validSelectedBuildingCapital && validSelectedLocality) {
                    NF.UI.Page.blockCustom({ message: "Buscando los mejores planes para vos." });
                    this.buildingCapital = this.tabThreeData.code;
                    this.buildTypeCode = this.tabThreeData.categoryId;
                    var dataWelcome = sessionStorage.getItem("TabOneWelcome");
                    if (dataWelcome != null) {
                        this.dataWelcomeJson = JSON.parse(dataWelcome!);
                        this.email = this.dataWelcomeJson.email;
                        this.areaCode = this.dataWelcomeJson.areaCode;
                        this.telephone = this.dataWelcomeJson.telephone;
                    }
                    const selectedDiscounts = [];
                    this.systemSecurity = [];
                    this.DescriptionDiscount20 = "";
                    this.DescriptionDiscount21 = "";
                    this.DescriptionDiscount22 = "";
                    this.DescriptionDiscount23 = "";

                    if (this.Discount20) {
                        this.DescriptionDiscount20 = "Sistema de detección de incendios";
                        this.systemSecurity.push(this.DescriptionDiscount20);
                        selectedDiscounts.push(20)
                    }
                    if (this.Discount21) {
                        this.DescriptionDiscount21 = "Personal de vigilancia";
                        this.systemSecurity.push(this.DescriptionDiscount21);
                        selectedDiscounts.push(21)
                    }
                    if (this.Discount22) {
                        this.DescriptionDiscount22 = "Puertas blindadas";
                        this.systemSecurity.push(this.DescriptionDiscount22);
                        selectedDiscounts.push(22)
                    }
                    if (this.Discount23) {
                        this.DescriptionDiscount23 = "Alarma contra robo monitoreada";
                        this.systemSecurity.push(this.DescriptionDiscount23);
                        selectedDiscounts.push(23)
                    }
                    sessionStorage.setItem("SecuritySystem", JSON.stringify(this.systemSecurity));

                    var body = JSON.stringify({
                        buildingCapital: this.buildingCapital,
                        buildTypeCode: this.buildTypeCode,
                        articleCode: parseInt(this.tabTwoData.articleCode.id),
                        cityId: parseInt(this.tabTwoData.selectedLocality.id),
                        zipCode: this.tabTwoData.selectedLocality.zipCode,
                        surfaceHouse: parseInt(this.tabTwoData.surfaceHouse),
                        email: this.dataWelcomeJson.email,
                        areaCode: this.dataWelcomeJson.areaCode,
                        telephone: this.dataWelcomeJson.telephone,
                        selectedDiscounts: selectedDiscounts,
                        productId: 927,
                        coverCode: 301
                    });
                    return new Promise<any>(async (resolve) => {
                        sessionStorage.setItem("FromPassTabTwo", "true");
                        await FamilyCombined.createFamilyCombined927Quotation(body).then(async responseFamilyCombined927Quotation => {
                            if (responseFamilyCombined927Quotation) {
                                const eventData = {
                                    'pas': this.pas,
                                    'email': this.dataWelcomeJson.email,
                                    'product': 'hogarPremium',
                                    'event': 'cotizador-hogar-premium-cotizacion',
                                    'referente': this.referente,
                                    'medio': this.medium
                                };

                                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                                window.globalThis.dataLayer.push(eventData);

                                const customWindow = window as typeof window & {
                                    _qsie?: Array<typeof eventData>;
                                };

                                customWindow._qsie ??= [];
                                customWindow._qsie.push(eventData);

                                var body = JSON.stringify({
                                    buildingCapital: this.buildingCapital,
                                    buildTypeCode: this.buildTypeCode,
                                    articleCode: parseInt(this.tabTwoData.articleCode.id),
                                    cityId: parseInt(this.tabTwoData.selectedLocality.id),
                                    zipCode: this.tabTwoData.selectedLocality.zipCode,
                                    surfaceHouse: parseInt(this.tabTwoData.surfaceHouse),
                                    email: this.dataWelcomeJson.email,
                                    areaCode: this.dataWelcomeJson.areaCode,
                                    telephone: this.dataWelcomeJson.telephone,
                                    selectedDiscounts: selectedDiscounts,
                                    productId: 927,
                                    coverCode: 301,
                                    quotationId: responseFamilyCombined927Quotation.quotationId,
                                    coverModuleCodes: "1",
                                    deductibleOption: 3,
                                    relationId: responseFamilyCombined927Quotation.relationId
                                });
                                this.Plans = responseFamilyCombined927Quotation.dataPlanQuotationComplete;
                                this.responseFamilyCombined927Quotation = responseFamilyCombined927Quotation;

                                await FamilyCombined.createFamilyCombined927Quotation(body).then(async responseQuotationWithDeductible => {
                                    if (responseQuotationWithDeductible) {
                                        this.Plans.push(responseQuotationWithDeductible.dataPlanQuotationComplete[0])
                                        await DiscountRangeService.getFamilyCombinedDiscountRange().then(async responseDiscountRange => {
                                            if (responseDiscountRange.length > 0) {
                                                this.containDiscountRange = true;
                                                this.discountRate = responseDiscountRange[0].discountMaxValue
                                                this.responseFamilyCombined927Quotation.discountRate = this.discountRate;
                                                NF.UI.Page.unblock();
                                            } else {
                                                this.containDiscountRange = false;
                                                NF.UI.Page.unblock();
                                            }
                                        });
                                        sessionStorage.setItem("DataQuotation", JSON.stringify(this.responseFamilyCombined927Quotation));
                                        resolve(true);
                                        sessionStorage.setItem("FromTabPassFour", "true");
                                        this.$router.push({
                                            name: 'tabFiveFamilyCombinedPremium',
                                        })
                                        NF.UI.Page.unblock();
                                    }
                                })
                            }
                            else {
                                const eventData = {
                                    'pas': this.pas,
                                    'email': this.dataWelcomeJson.email,
                                    'product': 'hogarPremium',
                                    'event': 'errorServidor',
                                    'paso': 'cotizador-hogar-premium-cotizacion',
                                    'referente': this.referente,
                                    'medio': this.medium
                                };

                                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                                window.globalThis.dataLayer.push(eventData);

                                const customWindow = window as typeof window & {
                                    _qsie?: Array<typeof eventData>;
                                };

                                customWindow._qsie ??= [];
                                customWindow._qsie.push(eventData);

                                NF.Notification.show({
                                    type: NF.Notification.Type.ERROR,
                                    title: 'Error',
                                    content: 'Se produjo un error al cotizar.',
                                    position: NF.Notification.Positions.TOP_RIGHT,
                                    clickClose: true,
                                    autoHideDelay: 10000,
                                });
                                NF.UI.Page.unblock();
                            }
                        }).catch(error => {
                            NF.UI.Page.unblock();
                            let statusCode = null;
                            // Si es un error de Axios (por ejemplo, 4xx, 5xx)
                            if (error.response && error.response.status) {
                                statusCode = error.response.status;
                            } else if (error.message === '204') {
                                // Error lanzado manualmente en el service para 204
                                statusCode = 204;
                            }

                            const eventData = {
                                'pas': this.pas,
                                'email': this.dataWelcomeJson.email,
                                'product': 'hogarPremium',
                                'event': 'errorServidor',
                                'paso': 'cotizador-hogar-premium-cotizacion',
                                'referente': this.referente,
                                'medio': this.medium
                            };

                            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                            window.globalThis.dataLayer.push(eventData);

                            const customWindow = window as typeof window & {
                                _qsie?: Array<typeof eventData>;
                            };

                            customWindow._qsie ??= [];
                            customWindow._qsie.push(eventData);

                            this.Bus.$emit('show-service-fail', statusCode, [() => this.cotizar()]);
                        });
                    })
                }
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                NF.UI.Page.unblock();
                this.tabTwoData = JSON.parse(sessionStorage.getItem("TabTwoData"));
                const dataFourTab = sessionStorage.getItem("TabFourData");

                if (dataFourTab != null) {
                    const DataDiscount = JSON.parse(dataFourTab);
                    if (DataDiscount) {
                        this.Discount20 = DataDiscount.Discount20;
                        this.Discount21 = DataDiscount.Discount21;
                        this.Discount22 = DataDiscount.Discount22;
                        this.Discount23 = DataDiscount.Discount23;
                    }
                }
                NF.UI.Page.unblock();
            }
        },

        watch: {
            Discount20(newVal) {
                if (newVal != null || newVal != "") {
                    this.Discount20 = newVal;
                    sessionStorage.removeItem('TabFourData');
                    sessionStorage.setItem('TabFourData', JSON.stringify({
                        Discount20: this.Discount20,
                        Discount21: this.Discount21,
                        Discount22: this.Discount22,
                        Discount23: this.Discount23,
                    }));
                }
            },
            Discount21(newVal) {
                if (newVal != null || newVal != "") {
                    this.Discount21 = newVal;
                    sessionStorage.removeItem('TabFourData');
                    sessionStorage.setItem('TabFourData', JSON.stringify({
                        Discount20: this.Discount20,
                        Discount21: this.Discount21,
                        Discount22: this.Discount22,
                        Discount23: this.Discount23,
                    }));
                }
            },
            Discount22(newVal) {
                if (newVal != null || newVal != "") {
                    this.Discount22 = newVal;
                    sessionStorage.removeItem('TabFourData');
                    sessionStorage.setItem('TabFourData', JSON.stringify({
                        Discount20: this.Discount20,
                        Discount21: this.Discount21,
                        Discount22: this.Discount22,
                        Discount23: this.Discount23,
                    }));
                }
            },
            Discount23(newVal) {
                if (newVal != null || newVal != "") {
                    this.Discount23 = newVal;
                    sessionStorage.removeItem('TabFourData');
                    sessionStorage.setItem('TabFourData', JSON.stringify({
                        Discount20: this.Discount20,
                        Discount21: this.Discount21,
                        Discount22: this.Discount22,
                        Discount23: this.Discount23,
                    }));
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                const eventData = {
                    'pas': this.pas,
                    'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                    'product': 'hogarPremium',
                    'event': 'cotizador-hogar-premium-medidas-seguridad',
                    'referente': this.referente,
                    'medio': this.medium
                };

                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                window.globalThis.dataLayer.push(eventData);

                const customWindow = window as typeof window & {
                    _qsie?: Array<typeof eventData>;
                };

                customWindow._qsie ??= [];
                customWindow._qsie.push(eventData);
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
